module.exports = __webpack_public_path__ + "static/media/BackdropBwMed2.79e85024.mp4";